/* eslint 'jsx-a11y/anchor-is-valid': 'off'  */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Label } from 'reactstrap';
import '../../../Assets/styles/home.css';
import * as ErrorMsg from '../../../Resources/ErrorMessages';
import {Redirect} from 'react-router-dom' ;
import NavigationBar from '../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';   
import Footer from '../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';                               /* Navigation Bar */


class GlobalErrorDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            backto_login: false
        };
        this.Back = this.Back.bind(this);  
    }

    Back(){
        this.setState({backto_login:true});
    }

    render(OnPremises) {
        if(this.state.backto_login === true){
            return  <Redirect to={"/ensemblelogin"} />
        }
     
        let lErrHeader = "Forbidden",lErrDetails="You don't have permission to access / on this server";
        if(this.props.ErrorStatus !== undefined && this.props.ErrorStatus !== null){
            let EStatus = this.props.ErrorStatus;
            switch(EStatus){
                case 400: lErrHeader = ErrorMsg.API_400_Header;
                    lErrDetails = ErrorMsg.API_400_Message;
                    break;
                case 401: lErrHeader = ErrorMsg.API_401_Header;
                    lErrDetails = ErrorMsg.API_401_Message;
                    break;
                case 403: lErrHeader = ErrorMsg.API_403_Header;
                    lErrDetails = ErrorMsg.API_403_Message;
                    break;
                case 404: lErrHeader = ErrorMsg.API_404_Header;
                    lErrDetails = ErrorMsg.API_404_Message;
                    break;
                case 500: lErrHeader = ErrorMsg.API_500_Header;
                    lErrDetails = ErrorMsg.API_500_Message;
                    break;
                case 502: lErrHeader = ErrorMsg.API_502_Header;
                    lErrDetails = ErrorMsg.API_502_Message;
                    break;
                default: lErrHeader = '';
                    lErrDetails = 'Cannot connect to Tracer Ensemble.';
                    break;
            }
            
        }

        if(this.props.OnPremises === undefined || !this.props.OnPremises){
            if(this.props.ErrorStatus === 401){
                return  (<Redirect to="/" />)
            }
            return(
                <div className="Ensemble_Content_FullPage">
                    <NavigationBar />
                    <div style={{"padding-top": "30px", "padding-left": "50px"}}>
                        <h3>{lErrHeader}</h3><br/>
                        <Label style={{"font-size": "16px"}}>{lErrDetails}</Label>
                        {/* <p className="link_cursor"  style={{ color: '#333',font:'15px' }}  onClick={() => { this.Back() }}  >Back</p> */}
                        <div style={{ "text-align": "center", "padding-top": "30px" }}>
                            <a className="links" onClick={() => this.Back()} >Back</a>
                        </div> 
                    </div> 
                    <Footer /> 
                </div>
            );
        }
        return(
            <div className="Ensemble_Content_FullPage">
                <div style={{"padding-top": "30px", "padding-left": "50px"}}>
                    <h3>{lErrHeader}</h3><br/>
                    <Label style={{"font-size": "16px"}}>{lErrDetails}</Label>
                    <br/><br/>
                    <hr/>
                </div> 
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ErrorStatus: state.authService.ErrorStatus,
        OnPremises: state.authService.IsOnPremise
    };
};

export default connect(mapStateToProps, null)(GlobalErrorDetails);